export default __webpack_public_path__ + "static/media/Cash-icon.eea27c28.svg";